
















































































import { Component, Emit, Model, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import CardTitle from '@/components/common/CardTitle.vue';
import { API, Storage } from 'aws-amplify';
import * as rules from "@/rules"

@Component({
    components: {
        DescriptionEditor,
        CardTitle
    },
})

export default class SimpleMenuTextEditor extends Vue {

    private readonly RULES = rules;
    private open = false;
    private internalValue = '';
    private internalDescription = '';
    private cancelEvent = false;
    private audioKeys = [];
    private nameEmpty = false;

    @Prop()
    show!: boolean;

    @Model('updated:text')
    value!: string;

    @Model('updated:text')
    description!: string;

    mounted() {
        this.internalValue = this.value;
        this.internalDescription = this.description;
        if (this.show) {
            setTimeout(() => (this.open = this.show), 200);
        }
    }

    @Watch('open')
    onOpenChange(newVal: boolean, oldVal: boolean) {
        if (!newVal && oldVal) {
            this.closedMenu();
        } else if (newVal) {
            this.internalValue = this.value;
            this.internalDescription = this.description;
            this.$emit('open');
        }
    }

    @Emit('save')
    @Emit('updated:text')
    private save() {
        if (!this.internalValue || this.internalValue == '' ) {
            this.nameEmpty = true;
            return;
        }
        this.audioKeys = [];
        this.open = false;
        return {
            name: this.internalValue,
            description: this.internalDescription,
        };
    }

    @Emit('cancel')
    private cancel() {
        this.nameEmpty = false;
        if(this.audioKeys.length > 0){
            this.audioKeys.forEach( (key: string) => {
                Storage.remove(key);
            });
            this.audioKeys = [];
        }
        this.internalValue = this.value;
        this.internalDescription = this.description;
        this.open = false;
    }

    @Emit('change')
    @Emit('updated:text')
    private updateValue(newValue: string) {
        this.open = false;
        return newValue;
    }

    @Emit('closed')
    private closedMenu() {
        return this.internalValue;
    }

    private checkName() {
        if ( this.internalValue === '' ) {
            this.nameEmpty = true;
        } else {
            this.nameEmpty = false;
        }
    }

    private clear() {
        this.nameEmpty = false;
        this.internalValue = "";
        this.internalDescription = "";
    }
}
